import { voteMatchesFilter } from '../../helpers'
import type { VoteDetail } from '../../models'

export interface PartyGroup {
  party: string
  members: VoteDetail[]
}

/**
 * Group vote details by party, then sort groups by:
 *   1. favor count descending
 *   2. contra count descending
 *   3. total member count descending
 *
 * Mirrors grouping.rs group_vote_details_by_party.
 */
export function groupVoteDetailsByParty(details: VoteDetail[]): PartyGroup[] {
  const groups: PartyGroup[] = []

  for (const detail of details) {
    const party = detail.party ?? 'Independiente'
    const existing = groups.find((g) => g.party === party)
    if (existing) {
      existing.members.push(detail)
    } else {
      groups.push({ party, members: [detail] })
    }
  }

  type GroupStats = { group: PartyGroup; favor: number; contra: number }
  const stats: GroupStats[] = groups.map((group) => ({
    group,
    favor: group.members.filter((d) => voteMatchesFilter(d.vote_choice, 'favor')).length,
    contra: group.members.filter((d) => voteMatchesFilter(d.vote_choice, 'contra')).length,
  }))

  stats.sort((a, b) => {
    if (b.favor !== a.favor) return b.favor - a.favor
    if (b.contra !== a.contra) return b.contra - a.contra
    return b.group.members.length - a.group.members.length
  })

  return stats.map((s) => s.group)
}
